import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import script from './CustomHint.vue_rollup-plugin-vue=script.js';

/* script */
const __vue_script__ = script;
/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("transition", { attrs: { name: "fade-in", mode: "out-in" } }, [
    _c("div", { ref: "message", staticClass: "spotlight-message" }, [
      _c(
        "header",
        { staticClass: "header" },
        [
          _c("h4", { staticClass: "title" }, [
            _c("span", [_vm._v(_vm._s(_vm.title))])
          ]),
          _vm._v(" "),
          _c("CrossIcon", {
            staticClass: "close-icon",
            attrs: { "primary-color": _vm.color, size: "small" },
            nativeOn: {
              click: function($event) {
                return _vm.onClose($event)
              },
              mouseenter: function($event) {
                return _vm.onEnter($event)
              },
              mouseleave: function($event) {
                return _vm.onLeave($event)
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { ref: "content", staticClass: "content" },
        [_vm._t("default")],
        2
      )
    ])
  ])
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = "data-v-11f2893c";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Spotlight/CustomHint.vue.js